import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import themeGet from '@styled-system/theme-get';
import { useTranslation } from 'react-i18next';

const DropdownButton = styled.div`
  margin-left: 8px;
  font-weight: 600;
  font-size: 14px;
  padding: 7px 16px;
  border-radius: 8px;
  color: ${themeGet('colors.black.80')};
  background: ${themeGet('colors.white')};
  border: 1px solid ${themeGet('colors.black.80')};
  line-height: 18px;
  pointer-events: auto;
  cursor: pointer;
  &:hover {
    color: ${themeGet('colors.black.60')};
    border-color: ${themeGet('colors.black.60')};
  }
`;

const ChevronDown = styled.i`
  margin-left: 2px;
`;

const PopdownButton = ({ bucketDate }) => {
  const { t } = useTranslation('edit');
  return (
    <DropdownButton
      data-tip={true}
      data-for={`dropdown-${bucketDate}`}
      data-event="click"
    >
      {t('actions')}
      <ChevronDown className={'fa-solid fa-chevron-down'}/>
    </DropdownButton>
  );
};

PopdownButton.propTypes = {
  bucketDate: PropTypes.string,
};

export default PopdownButton;
